// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.show-block {
    display: flex;
    width: 115px;
    align-items: center;
    justify-content: space-between;
}

.show-block__text {
    font-size: 10px;
}

.show-block__select {
    border: 1px solid #aaa;
    border-radius: 3px;
    padding: 5px;
    background-color: transparent;
    color: inherit;
    padding: 4px;
    width: 53px;
    height: 27px;
    font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/components/TryIt/Result/Show/Show.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,6BAA6B;IAC7B,cAAc;IACd,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,eAAe;AACnB","sourcesContent":[".show-block {\n    display: flex;\n    width: 115px;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.show-block__text {\n    font-size: 10px;\n}\n\n.show-block__select {\n    border: 1px solid #aaa;\n    border-radius: 3px;\n    padding: 5px;\n    background-color: transparent;\n    color: inherit;\n    padding: 4px;\n    width: 53px;\n    height: 27px;\n    font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
